





























































































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import FormItem from '@/components/formItem/index.vue'
import {
  fetchProductList,
  FetchPensionProType,
  saveIsProList,
  FetchIsGDetail,
} from '@/api/card/investCard'
import { newPersionList, savePension } from '@/api/newPersion'
import { CommonMudule } from '@/store/modules/common'
import { regularOpt } from '@/views/newPension/pensionCard/investCard/utils/index'
import NewFooter from '@/views/newPension/components/newFooter'
import { BtnList } from '@/types/common/btn'
import analyDialog from '@/views/newPension/pensionCard/investCard/coms/analyDialog.vue'
import {
  SingleActionsItem,
  AutoInvestActionsItem,
  SaveInvestPro,
  EditParams
} from '@/types/card/investCard'
import { cloneDeep } from 'lodash'
import { ElForm } from 'element-ui/types/form'

interface CalcCom extends Vue {
  show: Function
}

@Component({
  name: 'edit',
  components: {
    FormItem,
    NewFooter,
    calcDialog: () => import('@/views/newPension/pensionCard/investCard/coms/calcDialog.vue'),
    analyDialog,
  },
})
export default class extends Vue {
  @Prop() editParams!: EditParams | string;

  regularOpt = regularOpt;
  retireAge = 60;
  dialogShow = true;
  itemDetail = {};
  form = {
    years: 0,
    region: '',
    name: '',
  };

  optionData = [];
  singleList: SingleActionsItem[] = [];
  regularList: AutoInvestActionsItem[] = [];

  proTypeArr: { productTypeId: string; typeName: string }[] = [];
  proTypeMap = {};
  singleSet = new Set();
  regularSet = new Set();
  tabIdMap = {};

  activeName = '0';

  get opt () {
    return this.proTypeMap[this.activeName]
  }

  get singleListCalc () {
    return this.singleList.filter((item) => !item.deleted)
  }

  get regularListCalc () {
    return this.regularList.filter((item) => !item.deleted)
  }

  @Watch('activeName')
  watchActive (v1: string) {
    if (v1) {
      this.form.region = ''
    }
  }

  onDialog () {
    (this.$refs.calcDialogCom as CalcCom).show()
  }

  nextPage (btnInfo: BtnList) {
    if (btnInfo.btnType === 'ok') {
      this.confirm()
    }
    if (btnInfo.btnType === 'no') {
      this.$emit('on-click', 'input')
    }
    if (btnInfo.btnType === 'ananly') {
      this.confirm('analy')
    }
  }

  mounted () {
    console.log('this.editParams', this.editParams)
  }

  createFormatData () {
    const singleArr: SingleActionsItem[] = []
    const regularArr: AutoInvestActionsItem[] = []
    this.singleList.forEach((item) => {
      const singleItem = {
        deleted: false,
        customerId: CommonMudule.customerId,
        amount: item.amount,
        productId: item.tempProductId,
        productName: item.productName,
        automaticInvest: false,
        productTypeId: item.productTypeId
      }
      if (item.amount > 0) {
        singleArr.push(singleItem as SingleActionsItem)
      }
    })
    this.regularList.forEach((item) => {
      const regularItem = {
        deleted: false,
        customerId: CommonMudule.customerId,
        investPlanAutoTermAmount: item.investPlanAutoTermAmount,
        investPlanAutoFreq: item.investPlanAutoFreq,
        productId: item.tempProductId,
        productName: item.productName,
        automaticInvest: true,
        productTypeId: item.productTypeId
      }
      if (
        regularItem.investPlanAutoTermAmount > 0 &&
        regularItem.investPlanAutoFreq
      ) {
        regularArr.push(regularItem as AutoInvestActionsItem)
      }
    })
    return { singleArr, regularArr }
  }

  confirm (type?: string) {
    if (type !== 'analy') {
      const ret = this.$validator(this.$refs.investForm)
      if (ret) {
        this.$message.error('请填写投资组合名称')
        return false
      }
    }

    const promiseRet: Promise<boolean>[] = []
    const formArr = Array.prototype
      .concat(
        this.$refs.regularForm as ElForm[],
        this.$refs.singleForm as ElForm[]
      )
      .filter((item) => item)
    if (formArr.length > 0) {
      formArr.forEach((formItem: ElForm) => {
        const r: Promise<boolean> = new Promise((resolve, reject) => {
          formItem.validate((valid) => {
            if (valid) {
              resolve(valid)
            } else {
              reject(valid)
            }
            console.log('valid', valid)
          })
        })
        promiseRet.push(r)
      })
      Promise.all(promiseRet)
        .then(() => {
          this.save(type)
        })
        .catch(() => {
          this.$message.error('请填写必填项')
        })
    } else {
      this.save(type)
    }
  }

  async save (type?: string) {
    const { singleArr, regularArr } = this.createFormatData()
    if (singleArr.length === 0 && regularArr.length === 0) {
      this.$message.error('请完整填写投资组合')
      return false
    }
    let singleParam = []
    let regularParam = []
    if (!this.editParams) {
      singleParam = singleArr
      regularParam = regularArr
    } else {
      singleParam = this.singleList
      regularParam = this.regularList
    }
    const ISParams: SaveInvestPro = {
      years: this.form.years,
      name: this.form.name,
      autoInvestActions: regularParam,
      singleActions: singleParam,
      customerId: CommonMudule.customerId,
      storyLineType: 'Pension',
    }
    if (this.editParams) {
      ISParams.id = (this.editParams as EditParams).id
      ISParams.enabled = (this.editParams as EditParams).enabled
    }
    if (type === 'analy') {
      (this.$refs.analyDialogCom as CalcCom).show(ISParams)
    } else {
      const res = await saveIsProList(ISParams as SaveInvestPro)
      if (res.statusCode === 0 && res.data) {
        this.$message.success('操作成功')
        this.$emit('on-click', 'input')
      }
    }
  }

  singleDel (item: SingleActionsItem) {
    console.log('item1', item)
    const index = this.singleList.findIndex((single) => single.tempProductId === item.tempProductId)
    console.log('index1', index)
    if (index > -1) {
      console.log('this.singleList1', this.singleList)
      this.singleList.splice(index, 1)
      console.log('this.singleList2', this.singleList)
      const rItemIndex = this.proTypeMap[
        this.tabIdMap[item.productTypeId]
      ].findIndex(
        (autoItem: SingleActionsItem) =>
          autoItem.productName === item.productName
      )
      this.$set(
        this.proTypeMap[this.tabIdMap[item.productTypeId]][rItemIndex],
        'singleStatus',
        false
      )
      item.singleStatus = false
    }
  }

  regularDel (item: AutoInvestActionsItem) {
    const index = this.regularList.findIndex(
      (regular) => regular.tempProductId === item.tempProductId
    )
    if (index > -1) {
      this.regularList.splice(index, 1)
      item.regularStatus = false
      const rItemIndex = this.proTypeMap[
        this.tabIdMap[item.productTypeId]
      ].findIndex(
        (autoItem: SingleActionsItem) =>
          autoItem.productName === item.productName
      )
      this.$set(
        this.proTypeMap[this.tabIdMap[item.productTypeId]][rItemIndex],
        'regularStatus',
        false
      )
    }
  }

  singleAction (item: SingleActionsItem) {
    item.singleStatus = true
    item.productId = item.tempProductId
    const tItem = cloneDeep(item)
    tItem.automaticInvest = false
    this.singleList.unshift(tItem)
  }

  autoAction (item: AutoInvestActionsItem) {
    item.productId = item.tempProductId
    item.regularStatus = true
    const tItem = cloneDeep(item)
    tItem.automaticInvest = true
    this.regularList.unshift(tItem)
  }

  formatDetail () {
    this.singleList.forEach((item: SingleActionsItem) => {
      this.singleSet.add(item.productId)
    })

    this.regularList.forEach((item: AutoInvestActionsItem) => {
      this.regularSet.add(item.productId)
    })
  }

  async fetchDetail () {
    const res = await FetchIsGDetail({
      id: (this.editParams as EditParams).id,
    })
    console.log('detail', res)

    if (res.statusCode === 0 && res.data) {
      const { singleActions, autoInvestActions, name, years } = res.data
      this.singleList = cloneDeep(singleActions) || []
      this.regularList = cloneDeep(autoInvestActions) || []
      this.formatDetail()
      this.form.name = name
      this.form.years = years
      this.itemDetail = res.data
    }
  }

  async created () {
    console.log('this.editParams3', this.editParams)
    if (!this.editParams) {
      await this.fetchPensionInfo()
    } else {
      await this.fetchDetail()
    }
    await this.fetchPro()
  }

  async fetchPensionInfo () {
    const res = await newPersionList({
      customerId: CommonMudule.customerId,
    })
    if (res.statusCode === 0 && res.data) {
      const { retireAge, deathAge } = res.data
      const age = CommonMudule.customerInfo.age
      if (retireAge && deathAge) {
        this.form.years = retireAge - age
      } else {
        const params = {
          retireAge: 60,
          deathAge: 84,
        }
        this.form.years = params.retireAge - age
        this.onSavePension(params)
      }
    }
  }

  async onSavePension (params: object) {
    await savePension({
      ...params,
      customerId: CommonMudule.customerId,
    })
  }

  async fetchPro () {
    const res = await FetchPensionProType()
    console.log('res', res)
    const tempTypeArr: { productTypeId: string; typeName: string }[] = []
    const tempTypeMap = {}
    if (res.statusCode === 0 && res.data) {
      res.data.forEach(
        (item: { subProductTypes: { id: string; typeName: string }[] }) => {
          if (item.subProductTypes.length > 0) {
            item.subProductTypes.forEach(
              (
                itemProType: { id: string; typeName: string },
                index: number
              ) => {
                tempTypeArr.push({
                  productTypeId: itemProType.id,
                  typeName: itemProType.typeName,
                })
                if (!(itemProType.id in tempTypeMap)) {
                  tempTypeMap[itemProType.id] = []
                }
                this.tabIdMap[itemProType.id] = index
              }
            )
          }
        }
      )
      this.proTypeArr = tempTypeArr
    }

    const allFetch: Promise<{
      statusCode: number;
      data: { content: [] }
    }>[] = []
    this.proTypeArr.forEach((ipro) => {
      allFetch.push(
        fetchProductList({
          productTypeId: ipro.productTypeId,
          size: 1000,
          page: 0,
        })
      )
    })
    const resAll: {
      statusCode: number;
      data: { content: [] }
    }[] = await Promise.all(allFetch)
    resAll.forEach(
      (
        item: {
          statusCode: number;
          data: {
            content: {
              singleStatus: boolean;
              regularStatus: boolean;
              id: string;
              tempProductId: string
            }[]
          }
        },
        index: number
      ) => {
        if (item.statusCode === 0 && item.data) {
          const { content } = item.data
          if (this.editParams === 'create') {
            content.forEach(
              (itemPro: { singleStatus: boolean; regularStatus: boolean }) => {
                itemPro.singleStatus = false
                itemPro.regularStatus = false
              }
            )
            tempTypeMap[String(index)] = content || []
          } else {
            content.forEach(
              (itemPro: {
                singleStatus: boolean;
                regularStatus: boolean;
                id: string;
                tempProductId: string
              }) => {
                if (this.singleSet.has(itemPro.id)) {
                  itemPro.singleStatus = true
                }

                if (this.regularSet.has(itemPro.id)) {
                  itemPro.regularStatus = true
                }
                itemPro.tempProductId = itemPro.id
                Reflect.deleteProperty(itemPro, 'id')
              }
            )
            tempTypeMap[String(index)] = content || []
          }
        }
      }
    )
    this.proTypeMap = tempTypeMap
  }
}
